/**
 * @generated SignedSource<<c55a8fc767aacd48784c2174d02ea086>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FiltersMenu_project$data = {
  readonly id: string;
  readonly key: string;
  readonly " $fragmentType": "FiltersMenu_project";
};
export type FiltersMenu_project$key = {
  readonly " $data"?: FiltersMenu_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersMenu_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FiltersMenu_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "28835b235c086410d58a202ddf909221";

export default node;
